import { AutoCompleteResult } from '@awazevr/design-system.components.autocomplete'
import { Brand } from '@awazevr/design-system.components.awaze-theme-provider'
import { locationLookupClient } from '@awazevr/mfe-common.api.location-lookup-client'

import type { PublicConfig } from '@/config/env/types'

export const getAutoSuggestSearch = (
  brand: Brand,
  marketCode: string,
  appConfig: PublicConfig,
) => {
  const { APP_ENV: environment, LOCATION_API_KEY } = appConfig

  return async (
    searchTerm: string,
    accommodationType: string,
    propertiesOnly: boolean,
  ): Promise<AutoCompleteResult[]> => {
    const locationResult = await locationLookupClient(searchTerm, {
      brand: brand,
      language: marketCode,
      accommodationType: accommodationType,
      maxAutocompleteResults: 100,
      auth: {
        LOCATION_API_URL: `https://location-lookup.api.${environment}.age.awaze.com`,
        LOCATION_API_KEY,
      },
    })

    interface Property {
      id: string
      link: string
      title: string
      location: string
    }

    const mapPropertyToAutocomplete = (p: Property): AutoCompleteResult => ({
      id: p.id,
      link: p.link,
      name: p.title,
      subtitle: [p.id, p.location].join(', ').replace(/,\s*$/, ''),
      property: true,
    })

    return propertiesOnly
      ? locationResult
          .flatMap((p) =>
            p.property && 'property' in p && 'title' in p ? [p] : [],
          )
          .map((p) => mapPropertyToAutocomplete(p))
      : locationResult.map((l) =>
          l.property && 'property' in l && 'title' in l
            ? mapPropertyToAutocomplete(l)
            : (l as AutoCompleteResult),
        )
  }
}
